<template>
  <button 
    type="button" 
    class="btn" 
    :class="{
      'btn-busca-suave': iconeAcao === 'la-search',
      'btn-salvar-suave': iconeAcao === 'la-check',
      'btn-cancelar-suave': iconeAcao === 'la-times',
      'btn-acoes-suave': iconeAcao === 'la-plus',
      'btn-sm': (size == 'usm') || (size == 'sm'), 
      'btn-md': size == 'md', 
      'btn-lg': size == 'lg', 
      'btn-light': color == 'light', 
      'btn-primary': color == 'primary', 
      'btn-secondary': color == 'secondary', 
      'btn-success': color == 'success', 
      'btn-info': color == 'info', 
      'btn-warning': color == 'warning', 
      'btn-danger': color == 'danger', 
      'btn-dark': color == 'dark', 
      'btn-light-primary': color == 'light-primary'
    }" 
    :disabled="(disabled) || (isLoading)" 
    :style="{
      'width': width ? width : (block ? '100%' : ''), 
      'padding': size == 'usm' ? '2px 6px !important' : '',
      'white-space': width ? 'nowrap' : '',
      'overflow': width ? 'hidden' : '',
      'text-overflow': width ? 'ellipsis' : '',
      'font-size': size == 'usm' ? '11px !important' : '',
    }" 
    :data-bs-toggle="databstoggle" 
    :data-bs-target="databstarget"
    @click="$emit('click', $event)"
  >
    <span class="indicator-label">
      <i v-if="iconeAcao && !['la-check', 'la-times'].includes(iconeAcao)" class="las" :class="iconeAcao" aria-hidden="true" style="font-size: 16px;"></i>
      {{ label }}
      <i v-if="iconeAcao === 'la-times'" class="las la-times ms-1 pe-0" aria-hidden="true" style="font-size: 14px;"></i>
      <i v-if="iconeAcao === 'la-check' && !isLoading" class="ki-duotone ki-double-check" aria-hidden="true"><span class="path1"></span><span class="path2"></span></i>
      <span 
        v-if="isLoading" 
        class="spinner-border spinner-border-sm align-middle ms-2"
      ></span>
    </span>
  </button>
</template>

<script>
export default {
  name: "ButtonPadrao",
  emits: ["click"],
  props: [
    "label", 
    "disabled", 
    "isLoading", 
    "size", 
    "width",
    "color", 
    "block", 
    "databstoggle", 
    "databstarget"
  ],
  computed: {
    iconeAcao() {
      const normalizar = valor => String(valor || '').trim().toLocaleLowerCase();
      const label = normalizar(this.label);
      for (const [acao, icone] of Object.entries({Cancelar:'la-times', Salvar:'la-check', Adicionar:'la-plus'})) {
        const traducao = typeof this.$t === 'function' ? this.$t(acao) : acao;
        if ([acao, traducao].some(texto => label === normalizar(texto) || label.startsWith(normalizar(texto) + ' '))) return icone;
      }
      const acoes = { Buscar: 'la-search', Imprimir: 'la-print', 'Exportar CSV': 'la-file-csv', 'Voltar ao padrão': 'la-undo' };
      for (const [texto, icone] of Object.entries(acoes)) {
        const traducao = typeof this.$t === 'function' ? this.$t(texto) : texto;
        if (label === normalizar(texto) || label === normalizar(traducao)) return icone;
      }
      return '';
    }
  },
  methods: {
  }
}
</script>

<style>

</style>
